// Hero capability ledger (spec c.7 §2). Codes come only from the principals' bios.
// Row labels live in i18n (`hero.ledger.<key>`, added by WP-A).
import { team } from "./team";
import type { Principal, TeamKey } from "./team";

export type Capability = {
  key: "finance" | "logistics" | "assets" | "platform" | "serviceAi";
  codes: string[];
  /** The row renders only if at least one backer is visible. */
  backedBy: TeamKey[];
};

export const capabilities: Capability[] = [
  { key: "finance", codes: ["S/4HANA", "FI", "CO"], backedBy: ["raul"] },
  { key: "logistics", codes: ["MM", "SD", "EWM", "TM"], backedBy: ["efren"] },
  { key: "assets", codes: ["PM", "HCM", "SuccessFactors"], backedBy: ["raul"] },
  { key: "platform", codes: ["RISE with SAP", "MII"], backedBy: ["efren"] },
  // Secondary line; Marketing decides whether it shows (no backer → hidden by default).
  { key: "serviceAi", codes: ["Haptik on SAP"], backedBy: [] },
];

export const visibleCapabilities = (
  rows: Capability[] = capabilities,
  members: Principal[] = team
): Capability[] => {
  const visible = new Set(members.filter((m) => m.visible).map((m) => m.key));
  return rows.filter((r) => r.backedBy.some((k) => visible.has(k)));
};
